import { List, LayoutGrid } from "lucide-react"

// Reusable list/grid switch for a table toolbar. `options` defaults to the
// common list+grid pair but can be overridden by a future page that needs a
// different set of views (e.g. board/timeline).
const DEFAULT_OPTIONS = [
  { value: "list", label: "List view", icon: List },
  { value: "grid", label: "Grid view", icon: LayoutGrid },
]

export const ViewToggle = ({ value, onChange, options = DEFAULT_OPTIONS }) => (
  <div className="ds-view-toggle" role="group" aria-label="View">
    {options.map((opt) => {
      const Icon = opt.icon
      const active = opt.value === value
      return (
        <button
          key={opt.value}
          type="button"
          className={active ? "is-active" : undefined}
          aria-pressed={active}
          aria-label={opt.label}
          title={opt.label}
          onClick={() => onChange?.(opt.value)}
        >
          <Icon aria-hidden />
        </button>
      )
    })}
  </div>
)

export default ViewToggle
